<!--  -->
<template>
  <div>
    <div class>
      <Steps :active="3" :space="'20%'" align-center>
        <Step
          :title="$t('cert.baseinfo')"
          @click.native="on_click('certbase')"
        />
        <Step
          :title="$t('cert.ralacourse')"
          @click.native="on_click('certcourse')"
        />
        <Step
          :title="$t('cert.certtemplaterule')"
          @click.native="on_click('certrule')"
        />
        <Step
          :title="$t('cert.recertrule')"
          @click.native="on_click('certrerule')"
        />
        <Step
          :title="$t('cert.certassessmentdate')"
          v-if="dataForm.isCompensation == '10'"
          @click.native="on_click('certreassessment')"
        />
      </Steps>
    </div>
    <div style="margin-top: 20px; margin-bottom: 20px"></div>
    <el-card class="aui-card--fill" shadow="never">
      <!-- 认证获得年 -->
      <el-row style="border-bottom: 1px dotted #b4bccc; margin-bottom: 20px">
        <el-col :span="3">
          <div class="div-year-tip" style="line-height: 30px">
            <span class="el-input__prefix"
              ><em class="el-input__icon el-icon-date"></em
            ></span>
            <span style="margin-left: 35px; margin-right: 10px">{{
              $t("cert.certYear")
            }}</span>
          </div>
        </el-col>
        <el-col :span="1" style="margin-left: 115px">
          <el-button
            @click="goLeft"
            type="primary"
            style="
              width: 30px;
              height: 30px;
              padding: 0 !important;
              float: right;
              margin-right: 5px;
              background-color: #169bd5 !important;
            "
            ><em class="el-icon-arrow-left"></em
          ></el-button>
        </el-col>
        <el-col :span="16">
          <div style="word-break: keep-all; white-space: nowrap">
            <div
              ref="certYearBar"
              style="
                line-height: 30px;
                height: 47px;
                width: 100%;
                overflow-x: hidden;
                overflow-y: hidden;
                word-break: keep-all;
                white-space: nowrap;
              "
            >
              <template v-for="(item, index) in certYearArr">
                <div
                  :key="index"
                  style="border: 1px solid #dcdfe6"
                  :class="{
                    'div-year-before':
                      item < currentYear && reCertYear.indexOf(item) != -1,
                    'div-year-after':
                      item >= currentYear && reCertYear.indexOf(item) != -1,
                    'div-year-before-disabled':
                      item < currentYear &&
                      reCertYear.indexOf(item) == -1 &&
                      item != dataForm.selectYear,
                    'div-year-after-disabled':
                      item >= currentYear &&
                      reCertYear.indexOf(item) == -1 &&
                      item != dataForm.selectYear,
                    'div-year-current': item == dataForm.selectYear,
                  }"
                  @click="changeYear(item)"
                >
                  <span>{{ item }}</span>
                </div>
              </template>
            </div>
          </div>
        </el-col>
        <el-col :span="1">
          <el-button
            @click="goRight"
            type="primary"
            style="
              width: 30px;
              height: 30px;
              padding: 0 !important;
              margin-left: 5px;
              background-color: #169bd5 !important;
            "
            ><em class="el-icon-arrow-right"></em
          ></el-button>
        </el-col>
        <el-col :span="3">
          <!-- <el-button type="primary" :disabled="true">{{ $t('cert.addCertYear') }}</el-button> -->
        </el-col>
      </el-row>
      <!-- 延续认证规则设定 -->
      <div class="page_title">{{ $t("cert.certreRule") }}</div>
      <el-form
        label-position="left"
        label-width="auto"
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
      >
        <el-row :gutter="0">
          <!-- 延续年 -->
          <el-col :span="6">
            <el-form-item :label="$t('cert.annualRecert')" prop="annualRecert">
              <el-select
                v-model="dataForm.annualRecert"
                default-first-option
                @change="onChangeYearLoadData()"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item, index) in annualRecertArr"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="note_div"
        style="
          margin-top: -17px;
          margin-bottom: 20px;
          border-bottom: 1px dotted #b4bccc;
        "
      >
        <span style="font-size: 8pt">{{ $t("cert.annualRecertExplain") }}</span>
      </div>
      <!-- 选项与课程 -->
      <div style="overflow-x: hidden">
        <div class="note_div">
          <span style="font-size: 8pt">{{ $t("cert.ruleExplain") }}</span>
        </div>
        <!-- <el-button type="primary" :disabled="dataForm.selectYear < currentYear"
                  @click="insertOption()">{{ $t('cert.addOption') }}</el-button> -->
        <el-table
          :data="optionTableHeader"
          :show-header="false"
          style="width: 100%; text-align: left"
          :row-class-name="tableRowClassName"
          :cell-style="cellStyle"
          border
          stripe
          empty-text=" "
        >
       
          <!-- 课程名称 -->
          <el-table-column
            :label="$t('cert.coursename')"
            prop="courseName"
            min-width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <span :id="'coursename' + scope.$index">{{
                $t("cert.coursename")
              }}</span>
            </template>
          </el-table-column>
          <!-- 培训状态要求 -->
          <el-table-column
            :label="$t('cert.completeStatus')"
            prop="completeStatusSelect"
            :width="285"
            align="center"
          >
            <template slot-scope="scope">
              <span :id="'completeStatus' + scope.$index">{{
                $t("cert.completeStatus")
              }}</span>
            </template>
          </el-table-column>
          <!-- 学习对象 -->
          <el-table-column
            :label="$t('cert.coursekind')"
            prop="coursekind"
            :width="215"
            align="center"
          >
            <template slot-scope="scope">
              <span :id="'coursekind' + scope.$index">{{
                $t("cert.coursekind")
              }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <!-- <el-table-column align="center"
                          prop="handle"
                          :width="100"
                          :label="$t('handle')">
            <template slot-scope="scope">
              <span :id="'handle' + scope.$index">{{$t('handle')}}</span>
            </template>
          </el-table-column> -->
        </el-table>

        <el-table
          :data="optionList"
          id="download"
          :show-header="false"
          :cell-style="bodyCellStyle"
          type="index"
          border
          stripe
          empty-text=" "
        >
          <el-table-column label="" min-width="140px" align="left">
            <template slot-scope="options">
              <el-row :gutter="0" style="height: 20px">
                <el-col :span="3">
                  <div style="padding-top: 6px">
                    {{ $t("cert.ruleOption") }}:{{ options.$index + 1 }}
                  </div>
                </el-col>
                <el-col :span="4" v-if="optionList[options.$index].courseList.length > 0">
                     <div @mouseenter="moveDisplay(options.$index)">
                      <el-select
                        v-model="options.row.certTypeProp"
                        multiple
                        :disabled="true"
                        :title="attributeDisplay"
                        >
                        <el-option
                          v-for="(item, index) in completeStatusArrs"
                          :key="index"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
            </div>
                </el-col>
              <el-col :span="2" v-if="optionList[options.$index].courseList.length > 0">
                      <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="setOption(options.row)">{{ $t("cert.optionDescription")}}</el-button>
                
 <!-- 选项说明 -->
    <el-dialog
      :title="$t('cert.optionDescription')"
      width="30%"
      :visible.sync="dialogTableVisibleOption">
    <el-input
      type="textarea"
      :autosize="{ minRows: 6}"
      v-model="certOptionDescription"
      maxlength="25"
      :disabled="true"
      show-word-limit/>
  </el-dialog>
                </el-col>

                <el-col :span="1" style="line-height: 34px;margin-left: 10%;padding-bottom: 10px;">
                  <span>{{ $t("cert.closingDatepre") }}</span>
                </el-col>
                <el-col :span="3" style="padding-bottom: 10px;">
                  <el-date-picker
                    v-model="optionList[options.$index].closingDateStr"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :clearable="true"
                    :disabled="true"
                    style="width: 140px; float: left"
                  >
                  </el-date-picker>
                </el-col>
               <el-col :span="3" style="line-height: 34px;padding-left: 5%;padding-bottom: 10px;">
                  <span>{{ $t("cert.closingDate") }}</span>
                </el-col>
                <el-col :span="6" style="text-align: right">
                  <!-- <el-button type="text" :disabled="dataForm.selectYear < currentYear"
                                @click="addCourse(optionList[options.$index].courseList, options.$index)">{{ $t('cert.add') }}</el-button>
                    <el-button type="text" :disabled="dataForm.selectYear < currentYear"
                                @click="deleteOption(options.$index)">{{ $t('cert.delete') }}</el-button> -->
                </el-col>
              </el-row>
              <div v-show="optionList[options.$index].courseList.length > 0">
                <el-table
                  ref="tbl"
                  :key="'tableKey'"
                  :data="optionList[options.$index].courseList"
                  :show-header="false"
                  :cell-style="bodyCellStyle"
                  style="width: 100%; text-align: left"
                  border
                  stripe
                  empty-text=" "
                >
                  <el-table-column
                    label="courseName"
                    prop="courseNameCn"
                    min-width="100px"
                    show-overflow-tooltip
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    label="completeStatus"
                    prop="completeStatusSelect"
                    :width="285"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.completeStatusSelect"
                        multiple
                        :disabled="true"
                        :placeholder="$t('cert.selectTips')"
                      >
                        <el-option
                          v-for="(item, index) in completeStatusArr"
                          :key="index"
                          :label="item.name"
                          :value="item.code"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="coursekind"
                    prop="courseKind"
                    :formatter="courseKindFormatter"
                    :width="215"
                    show-overflow-tooltip
                    align="center"
                  >
                  </el-table-column>
                  <!-- <el-table-column label="handle"
                                    prop="handle"
                                    :width="100"
                                    align="center">
                      <template slot-scope="scope">
                        <el-button type="text" :disabled="dataForm.selectYear < currentYear" @click="deleteCourse(options.$index, scope.$index)">{{ $t('cert.delete') }}</el-button>
                      </template>
                    </el-table-column> -->
                </el-table>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div style="text-align: right">
      <el-row :gutter="0">
        <el-col :span="24"> </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="24">
          <el-button
            @click="close"
            v-if="dataForm.isCompensation != '10'"
            type="primary"
            >{{ $t("cert.return") }}</el-button
          >
          <el-button
            v-if="dataForm.isCompensation == '10'"
            @click="next"
            type="primary"
            >{{ $t("cert.next") }}</el-button
          >
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import courseds from "../../course/cscondition/courseds";
import Steps from "../../common/steps/index";
import Step from "../../common/steps/src/step";
import ZElButton from "../../common/button/index";
import Vue from "vue";
export default {
  components: {
    courseds,
    Steps,
    Step,
    ZElButton,
  },
  props: {
    requiredData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      textarea: '',
      attributeDisplay:'',
      certOptionDescription:'',
      dialogTableVisibleOption:false,
      optionTableHeader: [{ headernum: 1 }],
      optionList: [],
      completeStatusArr: this.enums["completeStatus"],
      completeStatusArrs: this.enums["certTypeProp"],
      dialogTableVisible: false,
      optionIndex: 0,
      courseInfoList: [],
      annualRecertArr: [],
      currentYear: 2019,
      certYearArr: [],
      dataForm: {
        certId: "",
        annual: "",
        selectYear: 2019,
        annualRecert: "",
        recertRuleId: "",
        isCompensation: "",
        authentication: "",
      },
      dataRule: {
        // annualRecert: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.annualRecert'), trigger: 'change' }]
        // recertFlag: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.recertFlag'), trigger: 'blur,change' }]
      },
      reCertYear: [],
    };
  },

  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log("created");
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log("mounted");
  },
  beforeCreate() {
    console.log("beforeCreate");
  }, // 生命周期 - 创建之前
  beforeMount() {
    console.log("beforeMount");
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
    console.log("beforeUpdate");
  }, // 生命周期 - 更新之前
  updated() {
    console.log("updated");
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    console.log("beforeDestroy");
  }, // 生命周期 - 销毁之前
  destroyed() {
    console.log("destroyed");
  }, // 生命周期 - 销毁完成
  activated() {
    console.log("activated");
  },

  // 方法集合
  methods: {
   moveDisplay(index) {
      let i = this.optionList[index].certTypeProp
      let obj = this.completeStatusArrs.find(item => item.code == i)
      if (obj.name.length >= 12 ) {
      this.attributeDisplay = obj.name
      } else {
        this.attributeDisplay = ''
      }
    },
    // 打开选项说明弹窗
    setOption(row) {
      this.dialogTableVisibleOption = true
      this.certOptionDescription = row.certOptionDescription
    },
    goLeft() {
      let left = this.$refs.certYearBar.scrollLeft;
      this.$refs.certYearBar.scrollLeft = left - 200;
    },
    goRight() {
      let left = this.$refs.certYearBar.scrollLeft;
      this.$refs.certYearBar.scrollLeft = left + 200;
    },
    init() {
      this.currentYear = this.requiredData.currentYear;
      this.dataForm.selectYear = this.requiredData.selectYear;
      this.certYearArr = this.requiredData.certYearArr;
      this.dataForm.certId = this.requiredData.certId;
      this.onLoadData(this.requiredData.certId, this.requiredData.selectYear);
    },
    on_click(stepname) {
      if (stepname === "certrerule") {
        return false;
      }
      this.$emit("onShowModer", stepname);
    },
    changeYear(year) {
      if (this.dataForm.selectYear === year) {
        return false;
      }
      this.$request
        .post(`/learning/certinfo/queryCertRuleInfo`, {
          certId: this.dataForm.certId,
          annual: year,
        })
        .then((res, total, code, data) => {
          this.$request
            .post(`/learning/certinfo/queryCertRuleInfo`, {
              certId: this.dataForm.certId,
              annual: year,
            })
            .then((resTwo, totalTwo, codeTwo, dataTwo) => {
              this.dataForm.isCompensation = dataTwo.data.isCompensation;
            })
            .catch((err) => {
              console.log(err);
            });

          if (data.data.recertFlag !== "10") {
            return false;
          }
          this.dataForm.selectYear = year;
          this.onCallBack();
          this.annualRecertArr = [];
          this.dataForm.annualRecert = parseInt(data.data.annual, 10) + 1;
          for (let i = 1; i <= parseInt(data.data.validPeriod, 10); i++) {
            this.annualRecertArr.push(parseInt(data.data.annual, 10) + i);
          }
          this.onChangeYearLoadData();
        });
    },
    addCertYear() {
      this.certYearArr.push(this.certYearArr[this.certYearArr.length - 1] + 1);
      this.onCallBack();
    },
    onLoadData(certId, annual) {
      this.$request
        .post(`/learning/certinfo/queryCertRuleInfo`, {
          certId: certId,
          annual: annual,
        })
        .then((res, total, code, data) => {
          if (data.data.certRuleInfoId === null) {
            // return this.$message.warning('该认证获得年没有对应的认证规则信息')
            return;
          }
          this.annualRecertArr = [];
          this.dataForm.isCompensation = data.data.isCompensation;
          this.dataForm.annualRecert = parseInt(data.data.annual, 10) + 1;
          for (let i = 1; i <= parseInt(data.data.validPeriod, 10); i++) {
            this.annualRecertArr.push(parseInt(data.data.annual, 10) + i);
          }
          this.reCertYear = data.data.reCertYear;
          this.onChangeYearLoadData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onChangeYearLoadData() {
      this.$request
        .post(`/learning/certinfo/queryCertRecertRule`, {
          certId: this.dataForm.certId,
          annual: this.dataForm.selectYear,
          annualRecert: this.dataForm.annualRecert,
        })
        .then((res, total, code, data) => {
          // if (data.data.recertRuleId === null) {
          //   return this.$message.warning('该认证获得年没有对应的延续认证规则信息')
          // }
          this.dataForm.annual = data.data.annual;
          this.dataForm.recertRuleId = data.data.recertRuleId;
          if (data.data.recertRuleId !== null) {
            data.data.optionList.forEach((row) => {
                row.certTypeProp = row.certTypeOptions.split(",");
              row.courseList.forEach((courseRow) => {
                courseRow.completeStatusSelect =
                  courseRow.completeStatus.split(",");
              });
            });
            this.optionList = data.data.optionList;
          } else {
            this.optionList = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCallBack() {
      this.$emit("onCallback", {
        selectYear: this.dataForm.selectYear,
        certYearArr: this.certYearArr,
      });
    },
    // 学习对象转换
    courseKindFormatter(row) {
      return Vue.filter("coverEnum")(row.courseKind, "newcourseKind");
    },
    close() {
      this.tabRemove();
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName;
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        });
      }
    },
    next() {
      this.$emit("onShowModer", "certreassessment");
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return "warning-row";
      }
      return "";
    },
    bodyCellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        background: "#fff",
      };
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property) {
        return {
          background: "#ebecf0 !important",
          color: "#333333",
        };
      }
    },
  }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
.div-year-tip {
  border-width: 0px;
  position: absolute;
  background-color: #c0c4cc;
  color: #ffffff;
}
.el-input__icon {
  color: #ffffff;
}
.div-year-before {
  border-width: 0px;
  background-color: rgba(172, 167, 167, 1);
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-current {
  border-width: 0px;
  background-color: rgba(255, 176, 23, 1) !important;
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-after {
  border-width: 0px;
  background-color: rgba(22, 155, 213, 1);
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-before-disabled {
  border-width: 0px;
  background-color: #c8c9cc;
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-after-disabled {
  border-width: 0px;
  background-color: #a0cfff;
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.ml_115p {
  margin-left: 115px;
}
.div-year-before:hover,
.div-year-current:hover,
.div-year-after:hover {
  cursor: pointer;
}
.div-year-after-disabled:hover,
.div-year-before-disabled:hover {
  cursor: not-allowed;
}
// 选项课程用
.el-table .warning-row {
  background: #ebecf0;
}
/deep/ .el-select__tags-text {
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/deep/.el-select .el-tag__close.el-icon-close {
    top: -7px;
}
</style>
